const MESI = [
  "gen", "feb", "mar", "apr", "mag", "giu",
  "lug", "ago", "set", "ott", "nov", "dic",
];
const GIORNI = ["dom", "lun", "mar", "mer", "gio", "ven", "sab"];

export function formatDateLong(dateStr) {
  // dateStr: YYYY-MM-DD
  if (!dateStr) return "";
  const [y, m, d] = dateStr.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  return `${GIORNI[dt.getDay()]} ${d} ${MESI[m - 1]}`;
}

export function confirmedAndWaitlist(match) {
  const confirmed = match.players.slice(0, match.total_slots);
  const waitlist = match.players.slice(match.total_slots);
  return { confirmed, waitlist };
}

export function buildWhatsappText(match) {
  const { confirmed, waitlist } = confirmedAndWaitlist(match);
  const link = `${window.location.origin}/?match=${match.id}`;
  const lines = [];
  lines.push("🎾 *PARTITA DI PADEL* 🎾");
  lines.push("");
  lines.push(`📅 ${formatDateLong(match.date)} alle ⏰ ${match.time}`);
  lines.push(`📍 ${match.venue}`);
  if (match.court_type) lines.push(`🏟️ ${match.court_type}`);
  if (match.level) lines.push(`🎯 Livello: ${match.level}`);
  if (match.price) lines.push(`💶 ${match.price} a testa`);
  lines.push("");
  lines.push(`👥 Giocatori ${confirmed.length}/${match.total_slots}`);
  confirmed.forEach((p, i) => lines.push(`   ${i + 1}. ${p.name}`));
  if (confirmed.length < match.total_slots) {
    const missing = match.total_slots - confirmed.length;
    lines.push(`   ➕ Mancano ${missing} ${missing === 1 ? "giocatore" : "giocatori"}!`);
  }
  if (waitlist.length > 0) {
    lines.push("");
    lines.push("⏳ *Lista d'attesa*");
    waitlist.forEach((p, i) => lines.push(`   #${i + 1} ${p.name}`));
  }
  if (match.notes) {
    lines.push("");
    lines.push(`📝 ${match.notes}`);
  }
  lines.push("");
  lines.push(`👉 Iscriviti qui: ${link}`);
  return lines.join("\n");
}

export function openWhatsapp(match) {
  const text = encodeURIComponent(buildWhatsappText(match));
  window.open(`https://wa.me/?text=${text}`, "_blank");
}

export function buildReminderText(match) {
  const { confirmed, waitlist } = confirmedAndWaitlist(match);
  const lines = [];
  lines.push("⏰ *PROMEMORIA PARTITA DI PADEL* 🎾");
  lines.push("");
  lines.push(`📅 Oggi ${formatDateLong(match.date)} alle ⏰ ${match.time}`);
  lines.push(`📍 ${match.venue}`);
  if (match.court_type) lines.push(`🏟️ ${match.court_type}`);
  if (match.price) lines.push(`💶 ${match.price} a testa`);
  lines.push("");
  lines.push(`👥 Si gioca! Convocati (${confirmed.length}/${match.total_slots}):`);
  confirmed.forEach((p, i) => lines.push(`   ${i + 1}. ${p.name}`));
  if (confirmed.length < match.total_slots) {
    const missing = match.total_slots - confirmed.length;
    lines.push(`   ⚠️ Mancano ancora ${missing} ${missing === 1 ? "giocatore" : "giocatori"}!`);
  }
  if (waitlist.length > 0) {
    lines.push("");
    lines.push("⏳ In lista d'attesa (pronti a subentrare):");
    waitlist.forEach((p, i) => lines.push(`   #${i + 1} ${p.name}`));
  }
  if (match.notes) {
    lines.push("");
    lines.push(`📝 ${match.notes}`);
  }
  lines.push("");
  lines.push("💪 Ci vediamo in campo, non mancate!");
  return lines.join("\n");
}

export function openWhatsappReminder(match) {
  const text = encodeURIComponent(buildReminderText(match));
  window.open(`https://wa.me/?text=${text}`, "_blank");
}

export function buildLeaderboardText(rows) {
  const medals = ["🥇", "🥈", "🥉"];
  const lines = [];
  lines.push("🏆 *CLASSIFICA PADEL* 🎾");
  lines.push("");
  rows.slice(0, 15).forEach((p, i) => {
    const pos = medals[i] || `${i + 1}.`;
    const flame = p.streak >= 2 ? ` 🔥${p.streak}` : "";
    lines.push(`${pos} ${p.name} — ${p.points} pt (${p.wins}V/${p.losses}S, ${p.win_rate}%)${flame}`);
  });
  lines.push("");
  lines.push("Vittoria = 3 pt · Sconfitta = 1 pt");
  lines.push(`👉 ${window.location.origin}`);
  return lines.join("\n");
}

export function openWhatsappLeaderboard(rows) {
  const text = encodeURIComponent(buildLeaderboardText(rows));
  window.open(`https://wa.me/?text=${text}`, "_blank");
}

export function buildPromotionText(match, promotedName) {
  const lines = [];
  lines.push(`🎉 *${promotedName}, sei entrato in partita!* 🎾`);
  lines.push("");
  lines.push("Si è liberato un posto e sei stato promosso dalla lista d'attesa.");
  lines.push("");
  lines.push(`📅 ${formatDateLong(match.date)} alle ⏰ ${match.time}`);
  lines.push(`📍 ${match.venue}`);
  lines.push("");
  lines.push(`👉 ${window.location.origin}/?match=${match.id}`);
  return lines.join("\n");
}

export function openWhatsappPromotion(match, promotedName) {
  const text = encodeURIComponent(buildPromotionText(match, promotedName));
  window.open(`https://wa.me/?text=${text}`, "_blank");
}

export function missingConfirmations(match) {
  const { confirmed } = confirmedAndWaitlist(match);
  const done = (match.confirmations || []).map((c) => c.toLowerCase());
  return confirmed.filter((p) => !done.includes(p.name.toLowerCase())).map((p) => p.name);
}

export function buildConfirmReminderText(match) {
  const missing = missingConfirmations(match);
  const { confirmed } = confirmedAndWaitlist(match);
  const lines = [];
  lines.push("✅ *CONFERMA PRESENZA* 🎾");
  lines.push("");
  lines.push(`📅 Oggi ${formatDateLong(match.date)} alle ⏰ ${match.time}`);
  lines.push(`📍 ${match.venue}`);
  lines.push("");
  lines.push(`Confermati: ${confirmed.length - missing.length}/${confirmed.length}`);
  if (missing.length) {
    lines.push("");
    lines.push("⚠️ Mancano le conferme di:");
    missing.forEach((n) => lines.push(`   • ${n}`));
    lines.push("");
    lines.push("Confermate con un tap qui 👇");
  } else {
    lines.push("");
    lines.push("🎉 Tutti hanno confermato, si gioca!");
  }
  lines.push(`👉 ${window.location.origin}/?match=${match.id}`);
  return lines.join("\n");
}

export function openWhatsappConfirmReminder(match) {
  const text = encodeURIComponent(buildConfirmReminderText(match));
  window.open(`https://wa.me/?text=${text}`, "_blank");
}

export function buildProfileText(player) {
  const link = `${window.location.origin}/?player=${encodeURIComponent(player.name)}`;
  const lines = [];
  lines.push(`🎾 *${player.name}* — Scheda giocatore`);
  lines.push("");
  lines.push(`🏆 ${player.points ?? 0} punti · ELO ${player.elo ?? 1000}`);
  lines.push(`📊 ${player.played ?? 0} partite · ${player.wins ?? 0}V/${player.losses ?? 0}S · ${player.win_rate ?? 0}%`);
  if (player.best_streak) lines.push(`🔥 Record serie: ${player.best_streak}`);
  lines.push("");
  lines.push(`👉 Guarda la scheda: ${link}`);
  return lines.join("\n");
}

export function openWhatsappProfile(player) {
  const text = encodeURIComponent(buildProfileText(player));
  window.open(`https://wa.me/?text=${text}`, "_blank");
}

const VOTE_MEDALS = ["🥇", "🥈", "🥉"];

export function buildVotesText(data) {
  const lines = [`🗳️ *Votazioni ${data.year} · Padel all'improvviso*`, ""];
  data.categories.forEach((cat) => {
    lines.push(`*${cat.label}*`);
    if (!cat.ranking.length) lines.push("Nessun voto ancora");
    let rank = 0;
    cat.ranking.slice(0, 3).forEach((r, i) => {
      if (i === 0 || r.votes !== cat.ranking[i - 1].votes) rank = i;
      lines.push(`${VOTE_MEDALS[rank]} ${r.name} · ${r.votes} ${r.votes === 1 ? "voto" : "voti"}`);
    });
    lines.push("");
  });
  if (data.is_open) lines.push(`Vota anche tu entro il 31/12 👉 ${window.location.origin}`);
  return lines.join("\n");
}

export function openWhatsappVotes(data) {
  window.open(`https://wa.me/?text=${encodeURIComponent(buildVotesText(data))}`, "_blank");
}
